module.exports = __webpack_public_path__ + "img/208-2089194_cartoon-team-members.26369284.png";